import { Collaboration, Content, Location, Storage } from "@dashboard-v3/api";
import { isBlank } from "utils/string";
import { Filepath } from "./types";
import { ParsedContent } from "../Actions/types";

export const controlsInit = () => ({
  enablePolicy: false,
  enableEmailSubfolder: false,
  enableBodySubfolder: false,
  enableAttachmentsSubfolder: false,
  enableCollaborate: false,
});

export const emptyLocation = (): Location => ({
  copyPolicy: null,
  emailSubfolder: null,
  folderStructure: null,
  parentId: null,
  parentName: null,
});

export const getCurrentPath = (value: Filepath) => {
  return getCurrentPathFromLocation(value?.location);
};

export const getCurrentPathFromLocation = (location: Location) => {
  if (!location) return "";
  const { parentName, folderStructure } = location;
  if (parentName) {
    return folderStructure ? `${parentName}/${folderStructure}` : parentName;
  }
  return folderStructure;
};

export const isValidPath = (val: string) => {
  return !isBlank(val);
};

export const isValidSubfolder = (storage: Storage) => {
  const { location } = storage;
  if ("emailSubfolder" in location) {
    return !isBlank(location.emailSubfolder);
  }
  if ("bodySubfolder" in location) {
    return !isBlank(location.bodySubfolder);
  }
  if ("attachmentsSubfolder" in location) {
    return !isBlank(location.attachmentsSubfolder);
  }
  return true;
};

export const isValidCollaboration = (storage: Storage) => {
  if ("collaboration" in storage) {
    return (
      !!storage.collaboration.position?.toString() &&
      !!storage.collaboration.role
    );
  }
  return true;
};

export function resetCollaboration(): Collaboration {
  const collaboration: Collaboration = {
    position: null,
    role: null,
  };

  return collaboration;
}

export const toParsedContent = (content: Content[]): ParsedContent =>
  content.reduce((acc, item) => {
    if (item.type === "EML" || item.type === "MSG") {
      return { ...acc, email: item };
    }
    if (item.type === "ATTACHMENTS") {
      return { ...acc, attachments: item };
    }
    if (item.type === "PDF") {
      return { ...acc, pdf: item };
    }
    return acc;
  }, {});

export const actionsByContentType = {
  email: (item: Content) => item.type === "EML" || item.type === "MSG",
  attachments: (item: Content) => item.type === "ATTACHMENTS",
  pdf: (item: Content) => item.type === "PDF",
};

export const formatTypeToField = (type: string) => {
  switch (type) {
    case "EML":
      return "email";
    case "ATTACHMENTS":
    case "PDF":
      return type.toLocaleLowerCase();
    default:
      return "";
  }
};
